var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-touch',{staticClass:"wrapper",on:{"swiperight":_vm.swiperright}},[_c('div',{staticClass:"error"},[_c('HeaderNav',{attrs:{"header-title":"开发中。。。","left-icon-name":"2","right-icon-name":"5","extr":{ leftCallBack: _vm.onClickLeft }}}),_c('section',[_c('p',[_vm._v(" 页面开发中 ")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }